var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCheckmarkSuccess20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.706 1.68a.75.75 0 1 1-.463 1.427 7.25 7.25 0 1 0 4.786 5.106.75.75 0 1 1 1.453-.371 8.75 8.75 0 1 1-5.776-6.161m4.825.8a.75.75 0 0 1 .21.957l-.06.094-7.616 10.153a.75.75 0 0 1-1.11.1l-.075-.081-3.385-4.23a.75.75 0 0 1 1.096-1.02l.075.082 2.78 3.475 7.035-9.38a.75.75 0 0 1 1.05-.15"
})));
export default SvgIcCheckmarkSuccess20X20;